module.exports = __webpack_public_path__ + "static/media/support.f07611a1.svg";